<template>
  <div class="homeBox" @click="upTopNav">
    <div style="height:2.3rem;overflow:hidden">
      <div class="tnavListBox">
        <div class="tnavList">
          <router-link :to="{name:'EnCorporateGovernance'}" class="tnavListLi">Company Governance</router-link>
          <router-link :to="{name:'EnInvestorContact'}" class="tnavListLi">Investors</router-link>
          <router-link :to="{name:'EnOfferDocuments'}" class="tnavListLi">Prospectus Document</router-link>
          <router-link :to="{name:'EnPeriodicalReport'}" class="tnavListLi">Periodic Report</router-link>
          <router-link :to="{name:'EnImportantAnnouncement'}" class="tnavListLi">Announcement</router-link>
        </div>
        <!-- <top-shadow class="topShadow"></top-shadow> -->
      </div>
    </div>
    <div class="investorTopBanner">
      <img class="investorTopBannerBackground" :src="banners[cat+'1']" alt="">
      <img class="investorTopBannerTextUp" :src="banners[cat+'2']" alt="">
      <img class="investorTopBannerTextDown" :src="banners[cat+'3']" alt="">
    </div>
    <router-view/>
    <div class="homeBotTxt">
      <p>Copyright ©2018 Scholar Education</p>
      <div>
        <router-link to="/en/LegalDeclaration" @click.native="changeHeadNavList">Legal Notices</router-link>
      </div>
    </div>
  </div>
</template>
<script>
  import '../../../../static/js/swiper.min.js';
  import Bus from '../../../router/bus.js';

  /**
   * 投资者关系
   */
  export default {
    name: 'Investor',
    data() {
      return {
        cat: 8000001,
        catName: '概述',
        banners: {},
        lastId: 0
      }
    },
    mounted() {
      let url = this.$root.baseUrl + '/investorReport/getBanners';
      this.axios.get(url)
        .then(res => {
          if (res['data']) this.banners = res['data'];
          console.log(res);
        })
        .catch(e => {
          console.log(e);
        });
      Bus.$on('changeCat', (cat) => {
        this.cat = cat;
      });
    },
    methods: {
      upTopNav: function () {
        document.getElementById("navLinkBox").classList.remove('active');
        document.getElementById("navLinkBox").style.transition = "0.5s";
      }
    }
  }
  document.onclick = function (e) {
    document.getElementById("navLinkBox").classList.remove('active');
    document.getElementById("navLinkBox").style.transition = "0.5s";
  }
</script>
<style scoped>



  .homeBotTxt{
    /* position: fixed; */
    /* bottom: 1rem; */
    text-align: center;
    font-size: 1rem;
    color: #333;
    width: 100%;
    z-index: 99;
    color: #333;
    /* font-weight: 100; */
    margin: 4.8rem 0 1.333rem 0;
  }
  .homeBotTxt p{
    margin-bottom: 0.5rem;
    color: #808080;
  }
  .homeBotTxt a{
    color: #bfbfbf;
    text-decoration: underline;
    font-size: 0.8rem;
    /* font-weight: 100; */
  }
  .homeBotTxt .l{
    font-size: 0.8rem;
    display: inline-block;
    font-weight: bold;
    margin: 0 0.5rem;
    color: #bfbfbf;
  }

  .investorTopBanner {
    position: relative;
    min-height: 100px;
  }

  .investorTopBannerTextUp {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-100%);
    max-width: 60%;
  }

  .investorTopBannerTextDown {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(100%);
    max-width: 60%;
  }

  .investorTopBannerBackground {
    width: 100%;
  }

  .homeBox {
    width: 100%;
    height: auto;
    margin: 3.2rem auto 0;
    font-size: 0;
  }

  .topShadow {
    -webkit-box-shadow: 0.1rem 0.2rem 0.1rem rgba(190, 190, 190, 0.25);
    box-shadow: 0.1rem 0.2rem 0.1rem rgba(190, 190, 190, 0.25);
    height: 0.1rem;
    display: inline-block;
    width: 100%;
    background: #fff;
    position: fixed;
    top: 4.45rem;
  }

  .tnavListBox {
    overflow: hidden;
    width: 100%;
    overflow-x: scroll;
    position: fixed;
    top: 3.2rem;
    background: #fff;
    height: 2.3rem;
    line-height: 1.8rem;
    box-shadow: 0 0 18px rgba(42, 42, 42, 0.1);
    z-index: 9;
  }

  .tnavList {
    height: 2.3rem;
    line-height: 1.8rem;
    width: 80rem;
    overflow: hidden;
  }

  .tnavListBox::-webkit-scrollbar { /*滚动条整体样式*/
    width: 0.1rem; /*高宽分别对应横竖滚动条的尺寸*/
    height: 0.1rem;
  }

  .tnavListLi {
    padding: 0.6rem 0;
    font-size: 0.9333rem;
    margin: 0 1rem;
  }

  .router-link-active {
    color: #333;
    border-bottom: 2px solid #ff7800;
  }

  a {
    color: #bfbfbf;
  }

</style>



// WEBPACK FOOTER //
// src/components/en/investor/Investor.vue